/** FNP = Filter Param Names */
export class FPN {
    static FILTER_PARAMS = [
        'booleanquery',
        'jobtitles',
        'exclude_jobtitles',
        'jobtitletype',
        'locations',
        'exclude_locations',
        'pastjobtitles',
        'exclude_pastjobtitles',
        'preferredskills',
        'companies',
        'exclude_companies',
        'companytype',
        'companysizes',
        'industries',
        'industrytype',
        'exclude_industries',
        'functions',
        'functiontype',
        'seniority',
        'fromyearsofexperience',
        'toyearsofexperience',
        'experiencetype',
        'currentfromyearsofexperience',
        'currenttoyearsofexperience',
        'genders',
        'educationaldegrees',
        'schools',
        'schoollocation',
        'exclude_schoollocation',
        'educationalmajors',
        'likelytomovetype',
        'changedjobs',
        'changedjobsstartdurationinmonths',
        'changedjobsenddurationinmonths',
        'fullnames'
    ];

    static MANDATORY_FILTER_PARAMS = [
        'mandatoryskills',
        'mandatoryjobtitles',
        'mandatorylocations',
        'mandatorycompanies',
        'mandatoryindustries',
        'mandatoryschools',
        'mandatoryfunctions',
        'mandatoryeducationalmajors',
        'mandatoryeducationaldegrees',
        'mandatoryseniority'
    ];

    static INSIGHTS_FILTER_PARAMS = [
        'insightslocations',
        'insightscompanies',
        'insightsindustries',
        'insightsschools',
        'insightseducationalmajors',
        'insightsjobtitles',
        'insightspastjobtitles',
        'insightspreferredskills',
        'insightsfunctions',
        'insightseducationaldegrees',
        'insightsseniority',
        'lastjobcompanies',
        'recentgraduatesonly',
        'recentcompanyhires',
        'recentcompanyattrition'
    ];
}